import React from 'react';
import { PawPrint, Check } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { CtaButton } from '../CtaButton';
import { stats, introChecks } from '../../data/content';
export function IntroSection() {
  return <section className="bg-white py-16 md:py-[84px]" data-id="element-130" data-mp="v3jniodg1daj">
      <div className="mx-auto grid max-w-[1120px] items-center gap-12 px-5 md:grid-cols-[.9fr_1.1fr]" data-id="element-131" data-mp="v31jv6ogbwsl">
        <Reveal className="order-2 grid grid-cols-2 gap-4 md:order-1" data-id="element-132" data-mp="q61c8rbyelzd">
          {stats.map(s => <div key={s.label} className="rounded-[22px] bg-cream px-[22px] py-[26px]" data-id="element-133" data-mp="lcgnlpw934cu">
              <b className="block font-display text-[44px] font-extrabold leading-none text-tangerine md:text-[56px]" data-id="element-134" data-mp="hcobj37neg2q">
                {s.value}
              </b>
              <span className="mt-1.5 block font-semibold text-forest" data-id="element-135" data-mp="7ei98khxj7xc">{s.label}</span>
            </div>)}
        </Reveal>
        <div className="order-1 md:order-2" data-id="element-136" data-mp="2g74go6hrnlz">
          <SectionHeading align="left" kicker="Te presento" icon={PawPrint} title={<>
                PASEO PRO: el kit de negocio para <em data-id="element-138" data-mp="1nnoiwg6xoj84">paseadores y cuidadores</em> de mascotas
              </>} lead="Todo lo que un servicio profesional necesita, ya diseñado, escrito y listo para usar. Solo pones tu nombre y empiezas hoy." data-id="element-137" data-mp="1iv563lg2ls4d" />
          <Reveal data-id="element-139" data-mp="21ld3dmx39ocn">
            <ul className="mt-6 flex flex-col gap-3" data-id="element-140" data-mp="21mxwd83r8z8e">
              {introChecks.map(c => <li key={c} className="flex items-start gap-3 text-[17px]" data-id="element-141" data-mp="26jemu8yffpon">
                  <span className="mt-px flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-tangerine" data-id="element-142" data-mp="1ro8e3e7y5crm">
                    <Check className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-143" data-mp="1wl8ilkp5e7gm" />
                  </span>
                  {c}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-144" data-mp="l8fy8uyoslal">
              <CtaButton data-id="element-145" data-mp="l5a6f7yob5b6">Quiero el kit completo</CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}